<template>
  <div class="rounded-t mb-0 px-4 py-3 border-0">
    <div class="text-center flex justify-between">
      <button @click="changeMonth(-1)"
        class="text-white bg-emerald-500 font-bold uppercase text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">
        <i class="fa fa-arrow-left" />
      </button>
      <div>
        <h5 class="text-blueGray-400 uppercase font-bold text-xs" v-if="subtitle">
          {{ subtitle }}
        </h5>
        <h3 class="font-semibold text-lg" :class="[color === 'light' ? 'text-blueGray-700' : 'text-white']">
          {{ title || `${$t('months.' + monthNames[month])} ${year}` }}
        </h3>
      </div>
      <button @click="changeMonth(1)"
        class="text-white bg-emerald-500 font-bold uppercase text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">
        <i class="fa fa-arrow-right" />
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import store from "@/store";
import DateUtils from '@/utils/dateUtils';

export default {
  data() {
    return {
      monthNames: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ],
    };
  },

  props: {
    title: {},
    subtitle: {},
    color: {
      default: "light",
      validator: function (value) {
        // The value must match one of these strings
        return ["light", "dark"].indexOf(value) !== -1;
      },
    },
  },

  computed: {
    ...mapState({
      startDateFromState: state => state.filters.startDate,
      endDateFromState: state => state.filters.endDate,
    }),

    dateFilter() {
      if (!this.startDateFromState && !this.endDateFromState) {
        store.dispatch("filters/update", DateUtils.getDefaultFilters());
      }

      const dateFilter = DateUtils.stringToDate(this.startDateFromState || this.endDateFromState);
      return dateFilter;
    },

    year() {
      return this.dateFilter.getFullYear();
    },

    month() {
      return this.dateFilter.getMonth(); // base 0
    },
  },

  methods: {
    changeMonth(param) {
      let month = this.month + param;
      const startDate = DateUtils.formatDate(new Date(this.year, month, 1));
      const endDate = DateUtils.formatDate(new Date(this.year, month + 1, 0));
      const filters = { startDate, endDate };
      store.dispatch("filters/update", filters);
    },
  }
};
</script>
